import React from 'react';
import { useTranslation } from 'react-i18next';
import { TablePlayer } from '../../types/tableGame';

interface PlayerNamesInputProps {
  players: TablePlayer[];
  onUpdatePlayer: (playerId: string, name: string) => void;
  disabled?: boolean;
}

const PlayerNamesInput: React.FC<PlayerNamesInputProps> = ({ 
  players, 
  onUpdatePlayer, 
  disabled = false 
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-3">
        {t('tableSetup.playerNames.title')}
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {players.map((player, index) => (
          <div key={player.id} className="relative">
            <label 
              htmlFor={`player-${player.id}`}
              className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-1"
            >
              {t('tableSetup.playerNames.label', { index: index + 1 })}
            </label>
            <input
              id={`player-${player.id}`}
              type="text"
              value={player.name}
              onChange={(e) => onUpdatePlayer(player.id, e.target.value)}
              disabled={disabled}
              maxLength={20}
              className={`
                w-full px-4 py-2.5 border-2 rounded-lg
                focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent
                transition-all duration-200
                ${disabled 
                  ? 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 cursor-not-allowed' 
                  : 'bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 hover:border-blue-300 dark:border-gray-700'
                }
              `}
              placeholder={t('tableSetup.playerNames.placeholder', { index: index + 1 })}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlayerNamesInput;
